export const SANDBOX_AGENT_BRAND = Symbol('openai.agents.sandbox_agent');
